import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import mediaQueries from "../../util/mediaqueries";
import styled from 'styled-components';
import HeadlineAndText from "../headline-and-text";
import { LAYOUT } from "./headline-module";
export var StyledHeadlineAndText = styled(HeadlineAndText).withConfig({
  componentId: "sc-11ke4ox-0"
})(["grid-column:1 / -1;margin-top:64px;", ";", ";", ";"], function (_ref) {
  var layout = _ref.layout;
  return layout === LAYOUT.DEFAULT && "margin-bottom: 64px";
}, mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    grid-column: 2 / -2;\n    margin-top: 96px;\n    ", ";\n  "])), 0)), function (_ref2) {
  var layout = _ref2.layout;
  return layout === LAYOUT.DEFAULT && "margin-bottom: 96px";
}), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-column: 3 / -3;\n  "]))))));